<template lang="pug">
  Base
    template(#title)
      b-form-row
        b-form-group.col(label="API Entity" label-cols="4" )
          b-form-select(:options="entities" v-model="entity_name" @change="loadEntityInfo" :disabled="busy")
        
        b-form-group.col-2
          b-button(variant="success" :disabled="busy" @click="invokeApi") Execute

    b-tabs
      b-tab(title="Metadata" @click="renderMetadataTab")
        .bg-light.d-flex.justify-content-between.p-2(v-if="info")
          .text-dark
            b-form-checkbox.mt-1.ml-3( inline switch v-model="showing_metadata_fields" :value="Boolean(true)" :unchecked-value="Boolean(false)" ) {{showing_metadata_fields ? "Showing Fields" : "Showing UDFs"}}
          .d-flex.justify-content-between
            .text-dark.ml-2 {{info.name}} Settings:
            .text-primary.ml-2(v-if="info.canQuery")
              b-icon-check
              span query
            .text-secondary.ml-2(v-if="!info.canQuery")
              b-icon-x
              span not queryable
            .text-success.ml-2(v-if="info.canCreate")
              b-icon-check
              span create
            .text-secondary.ml-2(v-if="!info.canCreate")
              b-icon-x
              span not createable
            .text-warning.ml-2(v-if="info.canUpdate")
              b-icon-check
              span update
            .text-secondary.ml-2(v-if="!info.canUpdate")
              b-icon-x
              span not updateable
            .text-danger.ml-2(v-if="info.canDelete")
              b-icon-check
              span delete
            .text-secondary.ml-2(v-if="!info.canDelete")
              b-icon-x
              span not deleteable
            .text-info.ml-2(v-if="info.hasUserDefinedFields")
              b-icon-check
              span user defined fields
            .text-info.ml-2(v-if="!info.hasUserDefinedFields")
              b-icon-x
              span no user defined fields
            .text-info.ml-2(v-if="info.supportsWebhookCallouts")
              b-icon-check
              span webhooks available
            .text-info.ml-2(v-if="!info.supportsWebhookCallouts")
              b-icon-x
              span webhooks not available
        
        b-table(:items="fields" :fields="table_fields" small striped sticky-header v-show="fields && showing_metadata_fields" style="max-height: 600px;")
          template(#head(name)="data")
            span {{info.name}} {{data.label}}
          template(#cell(picklistValues)="data")
            b-button(v-if="data.value.length>0" @click="data.toggleDetails" size="sm") {{data.value.length}} valid values
          template(#row-details="row")
            b-table(:items="row.item.picklistValues" :fields="picklist_fields" small striped table-variant="success" )
        
        b-table(:items="udf_fields" :fields="table_udf_fields" small striped sticky-header v-show="udf_fields && !showing_metadata_fields" style="max-height: 600px;")
          template(#head(namelabel)="data")
            span {{info.name}} {{data.label}}
            b-form-checkbox.mt-1.ml-3( inline switch v-model="field_labels_on" :value="Boolean(true)" :unchecked-value="Boolean(false)" ) {{field_labels_on ? "showing label" : "showing name"}}
          template(#cell(namelabel)="data")
            span {{field_labels_on ? data.item.label : data.item.name}} 
          template(#cell(picklistValues)="data")
            b-button(v-if="data.value.length>0" @click="data.toggleDetails" size="sm") {{data.value.length}} valid values
          template(#row-details="row")
            b-table(:items="row.item.picklistValues" :fields="picklist_fields" small striped table-variant="success" )

      b-tab(title="Query/Count" @click="renderQueryTab")
        b-button(block variant="primary" v-b-toggle.querybuilder  ) Build a Query
        b-collapse#querybuilder(visible).bg-light.p-3
          .row
            .col
              b-form-row
                b-form-group.col(label="Field" )
                  b-form-select(:options="qfields" v-model="current_filter.field" @input="checkFilterUdf" :disabled="busy")
                b-form-group.col-2(label="Operator" )
                  b-form-select(:options="filter_operators" v-model="current_filter.op" :disabled="busy")
                b-form-group.col-3(label="Value" )
                  b-form-input(v-model="current_filter.value" :disabled="busy")
                b-form-group
                  template(#label)
                    b-icon-arrow-right
                  b-button(variant="primary" @click="addFilter" ) Add Filter
              b-form-row(v-if="['query'].includes(action)" )
                b-input-group(label="Include Only Field(s)" label-cols="3" )
                  b-form-select(:options="qfields" v-model="include_field" :disabled="busy")
                  b-input-group-append
                    b-button(variant="primary" @click="includeField") Include This Field
            .col
              b-form-textarea(v-model="raw_query" rows="6" max-rows="10" style="font-size: .8em; font-family: Menlo,Consolas,Monaco,monospace;")

        .bg-light.p-3( v-if="autotask_result" fluid )
          
          .d-flex.justify-content-center
            span.text-success(v-if="ritems && ritems.length > 0") {{ritems.length}} Found
            span.text-danger(v-else="ritems") Nothing Found
            b-form-group.ml-3(v-if="ritems && ritems.length > 0")
              b-form-checkbox(v-model="labels_on" :value="Boolean(true)" :unchecked-value="Boolean(false)" switch) labels {{labels_on ? "on" : "off"}}
          
          b-table(v-if="ritems" :fields="rfields" :items="ritems" striped small sticky-header style="max-height: 600px;")
        
      b-tab(title="Get" @click="renderGetTab")
        .mt-1.d-flex.justify-content-center
          b-form-group(label="ID" label-cols="2" label-align="right" )
            b-form-input(v-model="id" :disabled="busy")
          b-form-group(v-if="autotask_result")
            b-form-checkbox.mt-1.ml-3(v-model="labels_on" :value="Boolean(true)" :unchecked-value="Boolean(false)" switch) labels {{labels_on ? "on" : "off"}}
          b-form-group(v-if="autotask_result")
            b-form-checkbox.mt-1.ml-3(v-model="show_all_fields" :value="Boolean(true)" :unchecked-value="Boolean(false)" switch) {{ show_all_fields ? "showing all fields" : "showing fields with values"}}
           
        div( v-if="autotask_result && ['get'].includes(action)" fluid )
          b-container.bg-light.p-3(visible)
            .text-center.mb-2
              span.text-success(v-if="ritem") Result
              span.text-danger(v-else="ritem") Nothing Found
            b-list-group(v-if="ritem")
              b-list-group-item.d-flex.justify-content-between.p-1.pl-2(v-for="v,k in ritemNoUdf" :key="'ritem_'+k" v-if="show_all_fields || !isFormattedFieldValueEmpty(k, v)")
                .text-dark {{k}}
                code.text-info {{formatFieldValue(k, v)}}
              b-list-group-item.d-flex.justify-content-between.p-1.pl-2(v-for="udf in ritem.userDefinedFields" :key="'ritem_udf_'+udf.name" v-if="show_all_fields || !isFormattedFieldValueEmpty(udf.name, udf.value)")
                .text-warning {{udf.name}}
                code.text-info {{formatFieldValue(udf.name, udf.value)}}
              
    
     

</template>

<script>
import Base from '@/components/Base.vue'
import {mapGetters, mapMutations} from 'vuex'
import {doFetch, ApiError} from '@/lib/api'
import {companyInfo, companyFields, companyUdfs} from '@/mixins/default-metadata'
import {filter_operators} from '@/mixins/valid-values'

export default {
  name: 'Explore',

  mixins: [],
  
  components: {
    Base,
  },
  
  props: {},

  data(){
    return {
      api_user: "",
      api_secret: "",
      api_integration_code: "",
      autotask_result: null,
      entity_name: "",

      current_filter: {
        field: null,
        op: "eq",
        udf: false,
        value: null,
      },
      include_field: null,

      filter_operators,

      action: null,
      entity: null,
      raw_query: "",//a string that will be parsed as a JSON object
      filters: [],
      id: null,

      entities: [
        {text:'ActionTypes', value:'ActionTypes'},
        {text:'AdditionalInvoiceFieldValues', value:'AdditionalInvoiceFieldValues'},
        {text:'Appointments', value:'Appointments'},
        {text:'AttachmentInfo', value:'AttachmentInfo'},
        {text:'ProjectCharges', value:'ProjectCharges'},
        {text:'BillingCodes', value:'BillingCodes'},
        {text:'BillingItems', value:'BillingItems'},
        {text:'BillingItemApprovalLevels', value:'BillingItemApprovalLevels'},
        {text:'ChangeOrderCharges', value:'ChangeOrderCharges'},
        {text:'ChangeRequestLinks', value:'ChangeRequestLinks'},
        {text:'ChecklistLibraries', value:'ChecklistLibraries'},
        {text:'ChecklistLibraryChecklistItems', value:'ChecklistLibraryChecklistItems', childOf: 'ChecklistLibraries', subname: 'ChecklistItems'},
        {text:'ClassificationIcons', value:'ClassificationIcons'},
        {text:'ClientPortalUsers', value:'ClientPortalUsers'},
        {text:'ComanagedAssociations', value:'ComanagedAssociations'},
        {text:'Companies', value:'Companies'},
        {text:'CompanyAlerts', value:'CompanyAlerts', childOf: 'Companies', subname: 'Alerts'},
        {text:'CompanyAttachments', value:'CompanyAttachments', childOf: 'Companies', subname: 'Attachments'},
        {text:'CompanyContacts', value:'CompanyContacts', childOf: 'Companies', subname: 'Contacts'},
        {text:'CompanyLocations', value:'CompanyLocations', childOf: 'Companies', subname: 'Locations'},
        {text:'CompanyNotes', value:'CompanyNotes', childOf: 'Companies', subname: 'Notes'},
        {text:'CompanySiteConfigurations', value:'CompanySiteConfigurations', childOf: 'Companies', subname: 'SiteConfigurations'},
        {text:'CompanyTeams', value:'CompanyTeams', childOf: 'Companies', subname: 'Teams'},
        {text:'CompanyToDos', value:'CompanyToDos', childOf: 'Companies', subname: 'ToDos'},
        {text:'CompanyWebhooks', value:'CompanyWebhooks'},
        {text:'CompanyWebhookExcludedResources', value:'CompanyWebhookExcludedResources', childOf: 'CompanyWebhooks', subname: 'ExcludedResources'},
        {text:'CompanyWebhookFields', value:'CompanyWebhookFields', childOf: 'CompanyWebhooks', subname: 'Fields'},
        {text:'CompanyWebhookUdfFields', value:'CompanyWebhookUdfFields', childOf: 'CompanyWebhoosk', subname: 'UdfFields'},
        {text:'ConfigurationItems', value:'ConfigurationItems'},
        {text:'ConfigurationItemBillingProductAssociations', value:'ConfigurationItemBillingProductAssociations', childOf: 'ConfigurationItems', subname: 'BillingProductAssociations'},
        {text:'ConfigurationItemCategories', value:'ConfigurationItemCategories'},
        {text:'ConfigurationItemCategoryUdfAssociations', value:'ConfigurationItemCategoryUdfAssociations', childOf: 'ConfigurationItemCategories', subname: 'UdfAssociations'},
        {text:'ConfigurationItemNotes', value:'ConfigurationItemNotes', childOf: 'ConfigurationItems', subname: 'Notes'},
        {text:'ConfigurationItemTypes', value:'ConfigurationItemTypes'},
        {text:'Contacts', value:'Contacts'},
        {text:'ContactBillingProductAssociations', value:'ContactBillingProductAssociations', childOf: 'Contacts', subname: 'BillingProductAssociationis'},
        {text:'ContactGroups', value:'ContactGroups'},
        {text:'ContactGroupContacts', value:'ContactGroupContacts', childOf: 'ContactGroups', subname: 'Contacts'},
        {text:'ContactWebhooks', value:'ContactWebhooks'},
        {text:'ContactWebhookExcludedResources', value:'ContactWebhookExcludedResources', childOf: 'ContactWebhooks', subname: 'ExcludedResources'},
        {text:'ContactWebhookFields', value:'ContactWebhookFields', childOf: 'ContactWebhooks', subname: 'Fields'},
        {text:'ContactWebhookUdfFields', value:'ContactWebhookUdfFields', childOf: 'ContactWebhooks', subname: 'UdfFields'},
        {text:'Contracts', value:'Contracts'},
        {text:'ContractBillingRules', value:'ContractBillingRules', childOf: 'Contracts', subname: 'BillingRules'},
        {text:'ContractBlocks', value:'ContractBlocks', childOf: 'Contracts', subname: 'Blocks'},
        {text:'ContractBlockHourFactors', value:'ContractBlockHourFactors', childOf: 'Contracts', subname: 'BlockHourFactors'},
        {text:'ContractCharges', value:'ContractCharges', childOf: 'Contracts', subname: 'Charges'},
        {text:'ContractExclusionBillingCodes', value:'ContractExclusionBillingCodes', childOf: 'Contracts', subname: 'ExclusionBillingCodes'},
        {text:'ContractExclusionRoles', value:'ContractExclusionRoles', childOf: 'Contracts', subname: 'ExclusionRoles'},
        {text:'ContractExclusionSets', value:'ContractExclusionSets'},
        {text:'ContractExclusionSetExcludedRoles', value:'ContractExclusionSetExcludedRoles', childOf: 'ContractExclusionSets', subname: 'ExcludedRoles'},
        {text:'ContractExclusionSetExcludedWorkTypes', value:'ContractExclusionSetExcludedWorkTypes', childOf: 'ContractExclusionSets', subname: 'ExcludedWorkTypes'},
        {text:'ContractMilestones', value:'ContractMilestones', childOf: 'Contracts', subname: 'Milestones'},
        {text:'ContractNotes', value:'ContractNotes', childOf: 'Contracts', subname: 'Notes'},
        {text:'ContractRates', value:'ContractRates', childOf: 'Contracts', subname: 'Rates'},
        {text:'ContractRetainers', value:'ContractRetainers', childOf: 'Contracts', subname: 'Retainers'},
        {text:'ContractRoleCosts', value:'ContractRoleCosts', childOf: 'Contracts', subname: 'RoleCosts'},
        {text:'ContractServices', value:'ContractServices', childOf: 'Contracts', subname: 'Services'},
        {text:'ContractServiceAdjustments', value:'ContractServiceAdjustments', childOf: 'Contracts'},
        {text:'ContractServiceBundles', value:'ContractServiceBundles', childOf: 'Contracts', subname: 'ServiceBundles'},
        {text:'ContractServiceBundleAdjustments', value:'ContractServiceBundleAdjustments', childOf: 'Contracts', subname: 'ServiceBundleAdjustments'},
        {text:'ContractServiceBundleUnits', value:'ContractServiceBundleUnits', childOf: 'Contracts', subname: 'ServiceBundleUnits'},
        {text:'ContractServiceUnits', value:'ContractServiceUnits', childOf: 'Contracts', subname: 'ServiceUnits'},
        {text:'ContractTicketPurchases', value:'ContractTicketPurchases', childOf: 'Contracts', subname: 'TicketPurchases'},
        {text:'Countries', value:'Countries'},
        {text:'Currencies', value:'Currencies'},
        {text:'Departments', value:'Departments'},
        {text:'ExpenseItems', value:'ExpenseItems', childOf: 'Expenses', subname: 'Items'},
        {text:'ExpenseReports', value:'ExpenseReports'},
        {text:'Holidays', value:'Holidays', childOf: 'HolidaySets', subname: 'Holidays'},
        {text:'HolidaySets', value:'HolidaySets'},
        {text:'InternalLocations', value:'InternalLocations'},
        {text:'InternalLocationWithBusinessHours', value:'InternalLocationWithBusinessHours'},
        {text:'InventoryItems', value:'InventoryItems'},
        {text:'InventoryItemSerialNumbers', value:'InventoryItemSerialNumbers', childOf: 'InventoryItems', subname: 'SerialNumbers'},
        {text:'InventoryLocations', value:'InventoryLocations'},
        {text:'InventoryTransfers', value:'InventoryTransfers'},
        {text:'Invoices', value:'Invoices'},
        {text:'InvoiceTemplates', value:'InvoiceTemplates'},
        {text:'NotificationHistory', value:'NotificationHistory'},
        {text:'Opportunities', value:'Opportunities'},
        {text:'OpportunityAttachments', value:'OpportunityAttachments', childOf: 'Opportunities', subname: 'Attachments'},
        {text:'OrganizationalLevel1', value:'OrganizationalLevel1'},
        {text:'OrganizationalLevel2', value:'OrganizationalLevel2'},
        {text:'OrganizationalLevelAssociations', value:'OrganizationalLevelAssociations'},
        {text:'OrganizatonalResources', value:'OrganizatonalResources', childOf: 'OrganizationalLevelAssociations', subname: 'Resources'},
        {text:'PaymentTerms', value:'PaymentTerms'},
        {text:'Phases', value:'Phases', childOf: 'Projects', subname: 'Phases'},
        {text:'PriceListMaterialCodes', value:'PriceListMaterialCodes'},
        {text:'PriceListProducts', value:'PriceListProducts'},
        {text:'PriceListProductTiers', value:'PriceListProductTiers'},
        {text:'PriceListRoles', value:'PriceListRoles'},
        {text:'PriceListServices', value:'PriceListServices'},
        {text:'PriceListServiceBundles', value:'PriceListServiceBundles'},
        {text:'PriceListWorkTypeModifiers', value:'PriceListWorkTypeModifiers'},
        {text:'Products', value:'Products'},
        {text:'ProductNotes', value:'ProductNotes', childOf: 'Products', subname: 'Notes'},
        {text:'ProductTiers', value:'ProductTiers', childOf: 'Products', subname: 'Tiers'},
        {text:'ProductVendors', value:'ProductVendors', childOf: 'Products', subname: 'Vendors'},
        {text:'Projects', value:'Projects'},
        {text:'ProjectAttachments', value:'ProjectAttachments', childOf: 'Projects', subname: 'Attachments'},
        {text:'ProjectCharges', value:'ProjectCharges', childOf: 'Projects', subname: 'Charges'},
        {text:'ProjectNotes', value:'ProjectNotes', childOf: 'Projects', subname: 'Notes'},
        {text:'PurchaseApprovals', value:'PurchaseApprovals'},
        {text:'PurchaseOrders', value:'PurchaseOrders'},
        {text:'PurchaseOrderItems', value:'PurchaseOrderItems', childOf: 'PurchaseOrders', subname: 'Items'},
        {text:'PurchaseOrderItemReceiving', value:'PurchaseOrderItemReceiving', childOf: 'PurchaseOrderItems', subname: 'Receiving'},
        {text:'Quotes', value:'Quotes'},
        {text:'QuoteItems', value:'QuoteItems', childOf: 'Quotes', subname: 'Items'},
        {text:'QuoteLocations', value:'QuoteLocations'},
        {text:'QuoteTemplates', value:'QuoteTemplates'},
        {text:'Resources', value:'Resources'},
        {text:'ResourceRoles', value:'ResourceRoles'},
        {text:'ResourceRoleDepartments', value:'ResourceRoleDepartments', childOf: 'Resources', subname: 'RoleDepartments'},
        {text:'ResourceRoleQueues', value:'ResourceRoleQueues', childOf: 'Resources', subname: 'RoleQueues'},
        {text:'ResourceServiceDeskRoles', value:'ResourceServiceDeskRoles', childOf: 'Resources', subname: 'ServiceDeskRoles'},
        {text:'ResourceSkills', value:'ResourceSkills', childOf: 'Resources', subname: 'Skills'},
        {text:'Roles', value:'Roles'},
        {text:'SalesOrders', value:'SalesOrders', childOf: 'Opportunities', subname: 'SalesOrders'},
        {text:'Services', value:'Services'},
        {text:'ServiceBundles', value:'ServiceBundles'},
        {text:'ServiceBundleServices', value:'ServiceBundleServices', childOf: 'ServiceBundles', subname: 'Services'},
        {text:'ServiceCalls', value:'ServiceCalls'},
        {text:'ServiceCallTasks', value:'ServiceCallTasks', childOf: 'ServiceCalls', subname: 'Tasks'},
        {text:'ServiceCallTaskResource', value:'ServiceCallTaskResource', childOf: 'ServiceCallTasks', subname: 'Resources'},
        {text:'ServiceCallTickets', value:'ServiceCallTickets', childOf: 'ServiceCalls', subname: 'Tickets'},
        {text:'ServiceCallTicketResource', value:'ServiceCallTicketResource', childOf: 'ServiceCallTickets', subname: 'Resources'},
        {text:'ServiceLevelAgreementResults', value:'ServiceLevelAgreementResults', childOf: 'ServiceLevelAgreements', subname: 'Results'},
        {text:'ShippingTypes', value:'ShippingTypes'},
        {text:'Skills', value:'Skills'},
        {text:'Subscriptions', value:'Subscriptions'},
        {text:'SubscriptionPeriods', value:'SubscriptionPeriods', childOf: 'Subscriptions', subname: 'Periods'},
        {text:'Surveys', value:'Surveys'},
        {text:'SurveyResults', value:'SurveyResults'},
        {text:'Tasks', value:'Tasks', childOf: 'Projects', subname: 'Tasks'},
        {text:'TaskAttachments', value:'TaskAttachments', childOf: 'Tasks', subname: 'Attachments'},
        {text:'TaskNotes', value:'TaskNotes', childOf: 'Tasks', subname: 'Notes'},
        {text:'TaskPredecessors', value:'TaskPredecessors', childOf: 'Tasks', subname: 'Predecessors'},
        {text:'TaskSecondaryResources', value:'TaskSecondaryResources', childOf: 'Tasks', subname: 'SecondaryResources'},
        {text:'Taxes', value:'Taxes'},
        {text:'TaxCategories', value:'TaxCategories'},
        {text:'TaxRegions', value:'TaxRegions'},
        {text:'ThresholdInformation', value:'ThresholdInformation'},
        {text:'Tickets', value:'Tickets'},
        {text:'TicketAdditionalConfigurationItems', value:'TicketAdditionalConfigurationItems', childOf: 'Tickets', subname: 'AdditionalConfigurationItems'},
        {text:'TicketAdditionalContacts', value:'TicketAdditionalContacts', childOf: 'Tickets', subname: 'AdditionalContacts'},
        {text:'TicketAttachments', value:'TicketAttachments', childOf: 'Tickets', subname: 'Attachments'},
        {text:'TicketCategories', value:'TicketCategories'},
        {text:'TicketCategoryFieldDefaults', value:'TicketCategoryFieldDefaults', childOf: 'TicketCategories', subname: 'FieldDefaults'},
        {text:'TicketChangeRequestApprovals', value:'TicketChangeRequestApprovals', childOf: 'Tickets', subname: 'ChangeRequestApprovals'},
        {text:'TicketCharges', value:'TicketCharges', childOf: 'Tickets', subname: 'Charges'},
        {text:'TicketChecklistItems', value:'TicketChecklistItems', childOf: 'Tickets', subname: 'ChecklistItems'},
        {text:'TicketChecklistLibraries', value:'TicketChecklistLibraries', childOf: 'Tickets', subname: 'ChecklistLibraries'},
        {text:'TicketHistory', value:'TicketHistory'},
        {text:'TicketNotes', value:'TicketNotes', childOf: 'Tickets', subname: 'Notes'},
        {text:'TicketRmaCredits', value:'TicketRmaCredits', childOf: 'Tickets', subname: 'RmaCredits'},
        {text:'TicketSecondaryResources', value:'TicketSecondaryResources', childOf: 'Tickets', subname: 'SecondaryResources'},
        {text:'TimeEntries', value:'TimeEntries'},
        {text:'UserDefinedFieldDefinitions', value:'UserDefinedFieldDefinitions'},
        {text:'UserDefinedFieldListItems', value:'UserDefinedFieldListItems', childOf: 'UserDefinedFields', subname: 'ListItems'},//note, no parent native entity
        {text:'WebhookEventErrorLogs', value:'WebhookEventErrorLogs'},
        {text:'WorkTypeModifiers', value:'WorkTypeModifiers'},
        {text:'ZoneInformation', value:'ZoneInformation'},

      ],

      info: null,
      fields: null,
      udf_fields: null,
      showing_metadata_fields: true,//or udfs
      field_labels_on: false,

      labels_on: true,
      show_all_fields: true,//vs only with values

      table_fields:[
        {
          key: "name",
          label: "Field",
        },
        {
          key: "dataType",
        },
        {
          key: "length",
          class: "text-right",
        },
        {
          key: "picklistValues",
          class: "text-center",
        },
        {
          key: "referenceEntityType",
          label: "Reference"
        },
        // {
        //   key: "isQueryable",
        //   label: "query",
        // },
        {
          key: "isReadOnly",
          label: "Readonly?",
          sortable: true,
          formatter: (value)=>{
            return value ? '✓' : '';
          }
        },
        {
          key: "isRequired",
          label: "Required?",
          sortable: true,
          formatter: (value)=>{
            return value ? '✓' : '';
          }
        },
        // {
        //   key: "isSupportedWebhookField",
        //   label: "webhook?",
        // },
        // {
        //   key: "picklistParentValueField",
        // },
        
      ],
      table_udf_fields:[
        {
          key: "namelabel",
          label: "User-Defined Field",
        },
        {
          key: "type",
          label: "Data Type",
        },
        {
          key: "length",

          class: "text-right",
        },
        {
          key: "picklistValues",
          class: "text-center",
        },
        {
          key: "referenceEntityType",
          label: "Reference"
        },
        // {
        //   key: "isQueryable",
        //   label: "query",
        // },
        {
          key: "isReadOnly",
          label: "Readonly?",
          sortable: true,
          formatter: (value)=>{
            return value ? '✓' : '';
          }
        },
        {
          key: "isRequired",
          label: "Required?",
          sortable: true,
          formatter: (value)=>{
            return value ? '✓' : '';
          }
        },
        // {
        //   key: "isSupportedWebhookField",
        //   label: "webhook?",
        // },
        // {
        //   key: "picklistParentValueField",
        // },
        
      ],
      picklist_fields:[
        {
          key: "label",
          sortable: true,
        },
        {
          key: "value",
          sortable: true,
        },
        {
          key: "sortOrder",
          sortable: true,
        },
        {
          key: "parentValue",
        },
        {
          key: "isActive",
          sortable: true,
          formatter: (value)=>{
            return value ? '✓' : '';
          }
        },
        // {
        //   key: "isDefaultValue",
        // },
        {
          key: "isSystem",
          sortable: true,
          formatter: (value)=>{
            return value ? '✓' : '';
          }
        },
      ]
    };
  },

  computed:{
    ...mapGetters(["busy","error","errors","has_error","has_message","message"]),
    has_api_info(){
      return this.api_user && this.api_secret && this.api_integration_code
    },
    actions(){
      if(!this.entity_name || !this.info) return [{text: "select an API Entity", disabled: true}];
      let actual = [
        {text: "-- Please Choose --", disabled: true},
        {value:"get", text: "Get by ID"},
      ];
      if(this.info){
        if(this.info.canQuery){ 
          actual.push({value:"count", text: "Count matching a query"});
          actual.push({value:"query", text: "Query"});
        }
        if(this.info.canCreate) actual.push({value:"create", text: "Create"});
        if(this.info.canUpdate) actual.push({value:"update", text: "Update by ID"});
        if(this.info.canDelete) actual.push({value:"delete", text: "Delete by ID"});
      }
      
      return actual;
    },
    qfields(){
      if(!this.fields) return [];
      let available =  this.fields.map(f => { return {text: f.name, value: f.name}; });
      if(this.udf_fields){
        this.udf_fields.forEach(f => { 
          available.push( {text: `(udf) ${f.name}`, value: f.name}); 
        });
      }
      return available;
    },
    rfields(){
      if(!this.fields || !this.autotask_result ) return [];
      let available =  this.fields.map(f => { 
        if(f.name === "userDefinedFields"){
          return null;
        } else if(this.autotask_result.query && this.autotask_result.query.IncludeFields && Array.isArray(this.autotask_result.query.IncludeFields) ){
          if(this.autotask_result.query.IncludeFields.includes(f.name)){
            return {
              key: f.name,
              formatter: (value)=>{
                if(!f.picklistValues || !this.labels_on) return value;
                let plv = f.picklistValues.find(plv=>plv.value==value);
                return plv ? plv.label : value;
              }
            };
            
          } else {
            return null;
          }
          
        } else {
          return {
            key: f.name,
            formatter: (value)=>{
              if(!f.picklistValues || !this.labels_on) return value;
              let plv = f.picklistValues.find(plv=>plv.value==value);
              return plv ? plv.label : value;
            }
          };
        }
      });// map fct

      if(this.info.hasUserDefinedFields && this.udf_fields){
        this.udf_fields.forEach(f => {
          if(this.autotask_result.query && this.autotask_result.query.IncludeFields && Array.isArray(this.autotask_result.query.IncludeFields) ){
            if(this.autotask_result.query.IncludeFields.includes(f.name)){
              available.push( {
                key: `${f.name}_udf`, 
                formatter: (value, key, item)=>{
                  let udf = item.userDefinedFields.find(u=>u.name===`${f.name}` );
                  return udf ? udf.value : null;
                }
              }); 
            } 
          } else {
            available.push( {
              key: `${f.name}_udf`, 
              formatter: (value, key, item)=>{
                let udf = item.userDefinedFields.find(u=>u.name===`${f.name}` );
                return udf ? udf.value : null;
              }
            }); 
          }

        });
      }

      let idFieldIdx = available.findIndex(f=>{return f.key === 'id'});
      if(idFieldIdx){
        //Move id field first.
        let found = available.splice(idFieldIdx, 1);
        console.log(found);
        available.splice(0, 1, found[0]);
      }
      return available;
    },
    ritems(){
      if(!this.autotask_result || !this.autotask_result.response || !this.autotask_result.response.items) return [];
      return this.autotask_result.response.items;
    },
    ritem(){
      if(!this.autotask_result || !this.autotask_result.response || !this.autotask_result.response.item ) return null;
      return this.autotask_result.response.item;
    },
    ritemNoUdf(){
      if(!this.autotask_result || !this.autotask_result.response || !this.autotask_result.response.item ) return null;
      let without = {};
      Object.assign(without, this.autotask_result.response.item);
      delete without.userDefinedFields;
      return without;
    },
    rcount(){
      if(!this.autotask_result || !this.autotask_result.response || !this.autotask_result.response.queryCount ) return 0;
      return this.autotask_result.response.queryCount;
    },
  },

  created(){
    this.loadApiInfoFromStorage();
    this.entity_name = "Companies";
    this.info = companyInfo;
    this.udf_fields = companyUdfs;
    this.fields = companyFields;
  },

  methods: {

    ...mapMutations(["clearMessageAndErrors","incrementInProcess","decrementInProcess","setError","setMessage"]),
    
    checkFilterUdf(){
      if(this.current_filter && this.current_filter.field){
        let existing = this.udf_fields.find(u=>u.name===this.current_filter.field);
        this.current_filter.udf = existing ? true : false;
      } else {
        this.current_filter.udf = false;
      }
    },

    addFilter(){
      if(this.current_filter && this.current_filter.field ){
        let q = this.parseRawQuery();
        if(q && q.filter && !Array.isArray(q.filter)){
          this.setError(`The "filter" property should be an array.`);
          return;
        }
        if(!q.filter) q.filter = []; 

        if(!this.current_filter.udf) delete this.current_filter.udf;//omit when false
        
        q.filter.push(this.current_filter);

        this.stringifyToRawQuery(q);
      }
    },
    includeField(){
      if(this.include_field){
        try{
          let q = this.parseRawQuery();

          if(q.IncludeFields && !Array.isArray(q.IncludeFields)){
            this.setError(`The "IncludeFields" property should be an array.`);
            return;
          }
          if(!q.IncludeFields){
            q.IncludeFields = [];
          }

          q.IncludeFields.push(this.include_field);

          this.stringifyToRawQuery(q);
        }catch(ex){
          this.setMessage("Invalid query JSON.");
          this.setError(ex.message)
        }
        
      }
    },
    parseRawQuery(){
      this.clearMessageAndErrors()
      if(this.raw_query){
        return JSON.parse(this.raw_query);
      } else {
        return {};
      }
    },
    stringifyToRawQuery(q){
      this.raw_query = JSON.stringify(q, null, 4);    
    },

    loadApiInfoFromStorage(){
      this.api_user = this.$offlineStorage.get('api_user');
      this.api_secret = this.$offlineStorage.get('api_secret');
      this.api_integration_code = this.$offlineStorage.get('api_integration_code');
    },

    async loadEntityInfo(){
      try{
        if(!this.entity_name) return;
        this.info = null,
        this.fields = [];
        this.udf_fields = [];
        this.filters = [];
        this.current_filter = {
          field: null,
          op: "eq",
          udf: false,
          value: null,
        };
        this.raw_query = "";
        this.id = "";
        this.entity = "";
        this.autotask_result = null;
        let metadata_done = Promise.all([
          this.getMetadataAboutEntity('info'),
          this.getMetadataAboutEntity('fieldInfo')
        ]);
        await metadata_done;
        if(this.info && this.info.hasUserDefinedFields){
          this.getMetadataAboutEntity('udfInfo')
        }
      }catch(ex){
        console.error(ex);
      }
    },

    async invokeApi(){
      if(!this.has_api_info){
        this.setError("Provide your credentials on the Home screen.")
        return;
      }
      try{
        this.clearMessageAndErrors();
        this.incrementInProcess();
        this.setMessage("Executing...");

        switch(this.action){
          case 'get':
            if(!this.id){
              this.setError("An id is required.");
              return;
            }
            break;
          case 'count':
            if(!this.raw_query){
              this.setError("A query is required.");
              return;
            }
            break;
          case 'query':
            if(!this.raw_query){
              this.setError("A query is required.");
              return;
            }
            break;
          case 'create':
            if(!this.entity){
              this.setError("An entity is required.");
              return;
            }
            break;
          case 'update':
            if(!this.entity){
              this.setError("An entity is required.");
              return;
            }
            if(!this.entity.id){
              this.setError("An id is required on the entity.");
              return
            }
            break;
          case 'delete':
            if(!this.id){
              this.setError("An id is required.");
              return
            }
            break;
        }

        let bodyPayload = {};
        bodyPayload.id = this.id;
        bodyPayload.entity = this.entity;
        bodyPayload.query = this.raw_query ? JSON.parse(this.raw_query) : null;
        bodyPayload.entity_name = this.entity_name;
        
        this.autotask_result = await doFetch(null, {
          method: 'POST',
          headers: {
            'x-autotask-api-user': this.api_user,
            'x-autotask-api-secret': this.api_secret,
            'x-autotask-api-integration-code': this.api_integration_code,
          },
          url: `/autotask/${this.entity_name}/${this.action}`,
          body: bodyPayload
          
        });

        this.setMessage("");

      }catch(ex){
        if(ex instanceof ApiError){
          this.setError(`Problem invoking API. ${ex.message}`);
        } else {
          this.setError(`Invalid action. Check your input. ${ex.message}`);
        }
        console.error(ex);
      } finally {
        this.decrementInProcess();
      }
    },
    /**
     * @param {string} metadata_type either 'info','fieldInfo','udfInfo'
     */
    async getMetadataAboutEntity(metadata_type){
      if(!this.has_api_info){
        this.setError("Provide your credentials on the Home screen.")
        return;
      } else if (!this.entity_name){
        return;
      }
      try{
        this.clearMessageAndErrors();
        this.incrementInProcess();
        this.setMessage(`Loading ${this.entity_name} metadata...`);

        let bodyPayload = {};
        bodyPayload.id = this.id;
        bodyPayload.entity = this.entity;
        bodyPayload.query = this.raw_query;
        bodyPayload.entity_name = this.entity_name;
        
        let res = await doFetch(null, {
          method: 'POST',
          headers: {
            'x-autotask-api-user': this.api_user,
            'x-autotask-api-secret': this.api_secret,
            'x-autotask-api-integration-code': this.api_integration_code,
          },
          url: `/autotask/${this.entity_name}/${metadata_type}`,
        });

        if(res.success && res.response){
          switch(metadata_type){
            case 'info':
              this.info = res.response.info;
              break;
            case 'fieldInfo':
              this.fields = res.response.fields;
              break;
            case 'udfInfo':
              this.udf_fields = res.response.fields;
              break;
          }
        }
        this.setMessage("");

      }catch(ex){
        if(ex instanceof ApiError){
          this.setError(`Problem invoking API. ${ex.message}`);
        }
        console.error(ex);
      } finally {
        this.decrementInProcess();
      }
    },
    formatFieldValue(key, raw){
      let field = this.fields.find(f=>f.name===key);
      if(!field) field = this.udf_fields.find(uf=>uf.name===key);
      if(!field) return raw;
      if(this.labels_on && field.isPickList){
        let pickListOption = field.picklistValues.find(plv=>plv.value==raw);
        if(pickListOption) return pickListOption.label;
      }
      return raw;
    },
    isFormattedFieldValueEmpty(key,raw){
      let theValue = this.formatFieldValue(key, raw);
      //this should return true for falsy values like 0, false
      return typeof theValue === 'undefined' || theValue === null || theValue==="";
      
    },
    renderQueryTab(){
      this.action = 'query';
    },
    renderGetTab(){
      this.action = 'get';
    },
    renderMetadataTab(){
      this.action = '';
    },
  },
  
}
</script>
